var map = {
	"./asha-phc-signup/asha-phc-signup.module": [
		"./src/app/asha-phc-signup/asha-phc-signup.module.ts",
		"asha-phc-signup-asha-phc-signup-module"
	],
	"./forget/forget.module": [
		"./src/app/forget/forget.module.ts",
		"common",
		"forget-forget-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"common",
		"login-login-module"
	],
	"./referral-signup/referral-signup.module": [
		"./src/app/referral-signup/referral-signup.module.ts",
		"common",
		"referral-signup-referral-signup-module"
	],
	"./signup/signup.module": [
		"./src/app/signup/signup.module.ts",
		"common",
		"signup-signup-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;